import React from "react";
import { Link } from "react-router-dom";
import { StyledAnchor } from "./_styled";
import useScrollToElement from "../../../hooks/useScrollToElement";
import { linkTypes, logTopicContentLinkClicked } from "../../../util/analytics";

export default function useLinkProcessor({
  isMobileDevice,
  isTabletDevice,
  telemetryData,
}) {
  const { scroll } = useScrollToElement({ isMobileDevice, isTabletDevice });
  const processLinks = (options) => {
    const { node, children, processDefault } = options;
    switch (node.attribs["data-location"]) {
      case "internal":
        return processInternalLink(
          node,
          children,
          processDefault,
          telemetryData
        );
      default:
        return processDefault(node, children);
    }
  };

  const processInternalLink = (
    node,
    children,
    processDefault,
    telemetryData
  ) => {
    switch (node.attribs["data-type"]) {
      case "jump":
        const href = node.attribs["href"];
        return (
          <StyledAnchor
            linkComponent={Link}
            onClick={(event) => {
              event.preventDefault();
              scroll(href.substring(1), true);
            }}
            href={href}
          >
            {children}
          </StyledAnchor>
        );
      case "article":
        return (
          <StyledAnchor
            linkComponent={Link}
            data-testid="article-anchor"
            href={node.attribs["href"]}
            onClick={() =>
              logTopicContentLinkClicked({
                ...telemetryData,
                linkText: children[0],
                linkUrl: node.attribs["href"],
                type: linkTypes.INTERNAL_TOPIC,
              })
            }
          >
            {children}
          </StyledAnchor>
        );
      default:
        return processDefault(node, children);
    }
  };

  return { processLinks };
}
